import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DataTable } from '../../../web/src/components/data-table.jsx';
import { translateColumns } from '../../../web/src/locale/translate-columns.js';
import { TRANSACTION_COLUMNS } from './../../../shared-site-web/screens/transaction-table.js';
import { useSiteLang } from '../layout/use-site-lang.js';
import { getMockTransactions } from './mock-data/mock-transactions.js';
import { inertActions, pairRow } from './mock-table.jsx';

/**
 * The transactions feed with transfer pairs, rendered with the app's real
 * DataTable + DoubleRow so the two-sided sublines look exactly like the app.
 * @param {{ rows?: Array<Record<string, unknown>>, columnKeys?: string[] }} [props]
 * @returns {JSX.Element}
 */
export function TransactionsCard({ rows, columnKeys } = {}) {
	const { t } = useTranslation();
	const lang = useSiteLang();
	const data = useMemo(() => rows ?? getMockTransactions(lang), [rows, lang]);
	const columns = useMemo(() => {
		const cols = columnKeys ? TRANSACTION_COLUMNS.filter((c) => columnKeys.includes(c.key)) : TRANSACTION_COLUMNS;
		return translateColumns(cols, t);
	}, [columnKeys, t]);
	return (
		<DataTable
			columns={columns}
			rows={data}
			title={t('page.title.transactions')}
			emptyMessage={t('empty.noTransactions')}
			renderRow={pairRow}
			renderActions={inertActions(t)}
		/>
	);
}
